'use strict';

const Route = require('common/route');

/**
 * リンク形式に変換された Element Mention を抽出するための正規表現を返す
 */
const matcher = function(context) {
    let baseURL = `${location.protocol}//${location.host}`;
    if (context.get().key.kind == 'Diagram') {
        const c = {
            projectId: context.getProject().id,
            diagramId: context.get().id
        };
        baseURL += Route.urlFor('path:diagram', c);
    }
    // 古いメンション記法 `<a href="#/elements/123">...</a> に対応させるため、baseUrlを省略可としている
    return new RegExp('^(?:__URL__)?#/elements/(\\w+)$'.replace(/__URL__/, baseURL));
};

class Mention {
    constructor(context, channel) {
        this._context = context;
        this._channel = channel;
    }

    /**
     * リンク形式に変換された Element の Mention に対して click された場合に
     * 対象の Element を選択状態にする Handler を付加する。
     */
    addClickHandler($el) {
        $el.find('a').each((i, el) => {
            const $e = $(el);
            const m = $e.attr('href') ? $e.attr('href').match(matcher(this._context)) : null;
            if (m) {
                const id = m[1];
                const models = this._channel.request(
                    'find:elements:idStartsWith', id);
                if (models.length != 1) {
                    return;
                }
                const model = models[0];
                $e.click(model.select.bind(model));
            }
        });
    }

    /**
     * リンク形式の Element Mention のID一覧を返す
     */
    fetchMentionData($el) {
        let results = [];

        $el.find('a').each((i, el) => {
            const $e = $(el);
            const m = $e.attr('href') ? $e.attr('href').match(matcher(this._context)) : null;
            if (m) {
                const id = m[1];
                const models = this._channel.request(
                    'find:elements:idStartsWith', id);
                if (models.length != 1) {
                    return;
                }
                const model = models[0];
                results.push(model.id);
            }
        });

        return results;
    }
}

module.exports = Mention;



// WEBPACK FOOTER //
// ./system/util/element-mention.js